import React, { createContext, useState, useEffect, useContext } from 'react';
import api from '../utils/api'; 

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const checkAuthStatus = async () => {
            const token = localStorage.getItem('token');
            if (token) {
                try {
                    const response = await api.get('/api/auth/status');
                    setIsAuthenticated(response.data.isAuthenticated);
                } catch (error) {
                    console.error('Error checking auth status:', error);
                    setIsAuthenticated(false);
                }
            }
        };

        checkAuthStatus();
    }, []);

    const login = async (credentials) => {
        try {
            const response = await api.post('/api/auth/login', credentials);
            localStorage.setItem('token', response.data.data.token);
            setIsAuthenticated(true);
        } catch (error) {
            console.error('Login error:', error);
            setIsAuthenticated(false);
            throw error; // Lanza el error para manejarlo en el formulario de login
        }
    };

    const logout = async () => {
        try {
            // Opcionalmente, puedes hacer una solicitud al backend para cerrar la sesión
            await api.post('/api/auth/logout');
        } catch (error) {
            console.error('Logout error:', error);
        } finally {
            // Asegúrate de eliminar el token y actualizar el estado de autenticación
            localStorage.removeItem('token');
            setIsAuthenticated(false);
        }
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
